import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Everton(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            I love my job overseeing Liverpool and the River Mersey. I can see
            everything that goes on, not that I am nosey of course, but you
            should see the antics of those other folk, I could write a book!
            would you like to know{" "}
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              more about me?
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            I was the first part of Liverpool to be occupied by rich merchant
            humans then their industry and human workers houses, which
            unfortunately became slums and people were moved to suburbs. I also
            housed lots of small quarries, the sandstone being used for local
            buildings. look and see{" "}
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              what I do now.
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            I host a heritage trail! I have a nature garden, two small lakes,
            woodland and meadowland and of course that wonderful view. Come and
            see my{" "}
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              famous little building
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Everton lock-up (Prince Rupert's Tower). Built using my sandstone in
            1787 and used to keep criminals overnight. Now it's image is part of
            Everton Football Club's emblem - how good is that?
          </p>
        </div>
      </div>
    );
  }
}

export default Everton;
